import * as React from "react";
import { useSearchParams } from "react-router-dom";

// /**
//  * The theme components only imports it's theme CSS-file. These components are lazy
//  * loaded, to enable "code splitting" (in order to avoid the themes being bundled together)
//  */
const DemoTheme = React.lazy(() => import("./DemoTheme"));

const ThemeSelector: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const isDemo = Boolean(searchParams.get("demo")) || false;

  return (
    // class from demo css
    <div className="site-wrapper">
      {/* Conditionally render theme, based on the current client context */}
      <React.Suspense fallback={null}>{isDemo && <DemoTheme />}</React.Suspense>
      {/* Render children immediately! */}
      {children}
    </div>
  );
};

export default ThemeSelector;
